(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js', './fixers-s2-s2-automate-s2-automate-dsl.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js', './boislocal-platform-platform-infra-commons-commons-domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./fixers-s2-s2-automate-s2-automate-dsl.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'), require('./boislocal-platform-platform-infra-commons-commons-domain.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'.");
    }
    if (typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'. Its dependency 'fixers-s2-s2-automate-s2-automate-dsl' was not found. Please, check whether 'fixers-s2-s2-automate-s2-automate-dsl' is loaded prior to 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'. Its dependency 'boislocal-platform-platform-infra-commons-commons-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-commons-commons-domain' is loaded prior to 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'.");
    }
    root['boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'] = factory(typeof this['boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib'], this['fixers-s2-s2-automate-s2-automate-dsl'], this['fixers-f2-f2-dsl-f2-dsl-cqrs'], this['boislocal-platform-platform-infra-commons-commons-domain']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_io_komune_s2_s2_automate_dsl, kotlin_io_komune_f2_f2_dsl_cqrs, kotlin_org_boislocal_commons_domain) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.ge;
  var protoOf = kotlin_kotlin.$_$.fa;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var THROW_IAE = kotlin_kotlin.$_$.ld;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var Enum = kotlin_kotlin.$_$.zc;
  var defineProp = kotlin_kotlin.$_$.b9;
  var S2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.j;
  var classMeta = kotlin_kotlin.$_$.z8;
  var S2TransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.b;
  var toValue = kotlin_io_komune_s2_s2_automate_dsl.$_$.m;
  var toValue_0 = kotlin_io_komune_s2_s2_automate_dsl.$_$.n;
  var getKClass = kotlin_kotlin.$_$.f;
  var toValue_1 = kotlin_io_komune_s2_s2_automate_dsl.$_$.l;
  var S2Transition = kotlin_io_komune_s2_s2_automate_dsl.$_$.k;
  var S2SelfTransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.a;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.j5;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var s2Sourcing = kotlin_io_komune_s2_s2_automate_dsl.$_$.c;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.da;
  var S2Role = kotlin_io_komune_s2_s2_automate_dsl.$_$.i;
  var S2InitCommand = kotlin_io_komune_s2_s2_automate_dsl.$_$.h;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var WithS2Id = kotlin_io_komune_s2_s2_automate_dsl.$_$.e;
  var Event = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.d;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var $serializer_getInstance = kotlin_org_boislocal_commons_domain.$_$.g;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var toString = kotlin_kotlin.$_$.le;
  var equals = kotlin_kotlin.$_$.c9;
  var S2Command = kotlin_io_komune_s2_s2_automate_dsl.$_$.g;
  var Long = kotlin_kotlin.$_$.ed;
  var WithS2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.f;
  var Roles_instance = kotlin_org_boislocal_commons_domain.$_$.b;
  var hasRole = kotlin_org_boislocal_commons_domain.$_$.m;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var isAvailableTransition = kotlin_io_komune_s2_s2_automate_dsl.$_$.d;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var PageQueryDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.a;
  var PageQueryResultDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor(WoodSpeciesState, 'WoodSpeciesState', classMeta, Enum, [Enum, S2State], VOID, VOID, {0: Companion_getInstance});
  setMetadataFor(S2, 'S2', objectMeta);
  setMetadataFor(UserRole, 'UserRole', classMeta, VOID, [S2Role], VOID, VOID, {0: $serializer_getInstance_0});
  setMetadataFor(User, 'User', objectMeta, UserRole);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(WoodSpeciesCreateCommandDTO, 'WoodSpeciesCreateCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(WoodSpeciesCreatedEventDTO, 'WoodSpeciesCreatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(WoodSpeciesCreateCommand, 'WoodSpeciesCreateCommand', classMeta, VOID, [WoodSpeciesCreateCommandDTO], VOID, VOID, {0: $serializer_getInstance_1});
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(WoodSpeciesCreatedEvent, 'WoodSpeciesCreatedEvent', classMeta, VOID, [WoodSpeciesCreatedEventDTO], VOID, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(WoodSpeciesDeleteCommandDTO, 'WoodSpeciesDeleteCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(WoodSpeciesDeletedEventDTO, 'WoodSpeciesDeletedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(WoodSpeciesDeleteCommand, 'WoodSpeciesDeleteCommand', classMeta, VOID, [WoodSpeciesDeleteCommandDTO], VOID, VOID, {0: $serializer_getInstance_3});
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(WoodSpeciesDeletedEvent, 'WoodSpeciesDeletedEvent', classMeta, VOID, [WoodSpeciesDeletedEventDTO], VOID, VOID, {0: $serializer_getInstance_4});
  setMetadataFor(WoodSpeciesImportCommandDTO, 'WoodSpeciesImportCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(WoodSpeciesImportedEventDTO, 'WoodSpeciesImportedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(WoodSpeciesImportCommand, 'WoodSpeciesImportCommand', classMeta, VOID, [WoodSpeciesImportCommandDTO], VOID, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(WoodSpeciesImportedEvent, 'WoodSpeciesImportedEvent', classMeta, VOID, [WoodSpeciesImportedEventDTO], VOID, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(WoodSpeciesUpdateCommandDTO, 'WoodSpeciesUpdateCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(WoodSpeciesUpdatedEventDTO, 'WoodSpeciesUpdatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(WoodSpeciesUpdateCommand, 'WoodSpeciesUpdateCommand', classMeta, VOID, [WoodSpeciesUpdateCommandDTO], VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(WoodSpeciesUpdatedEvent, 'WoodSpeciesUpdatedEvent', classMeta, VOID, [WoodSpeciesUpdatedEventDTO], VOID, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(WoodSpeciesModelDTO, 'WoodSpeciesModelDTO', interfaceMeta, VOID, [WithS2State, WithS2Id]);
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor($serializer_8, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(WoodSpeciesModel, 'WoodSpeciesModel', classMeta, VOID, [WoodSpeciesModelDTO], VOID, VOID, {0: $serializer_getInstance_9});
  setMetadataFor(WoodSpeciesPolicies, 'WoodSpeciesPolicies', objectMeta);
  setMetadataFor(WoodSpeciesGetQueryDTO, 'WoodSpeciesGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(WoodSpeciesGetResponseDTO, 'WoodSpeciesGetResponseDTO', interfaceMeta);
  setMetadataFor(WoodSpeciesPageQueryDTO, 'WoodSpeciesPageQueryDTO', interfaceMeta, VOID, [PageQueryDTO]);
  setMetadataFor(WoodSpeciesPageResponseDTO, 'WoodSpeciesPageResponseDTO', interfaceMeta, VOID, [PageQueryResultDTO]);
  //endregion
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.x2k_1.f2();
  }
  function WoodSpeciesState$Companion$_anonymous__u0k6ib() {
    return createSimpleEnumSerializer('org.boislocal.platform.s2.woodSpecies.domain.automate.WoodSpeciesState', values());
  }
  var WoodSpeciesState_Exists_instance;
  var WoodSpeciesState_Deleted_instance;
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x2k_1 = lazy(tmp_0, WoodSpeciesState$Companion$_anonymous__u0k6ib);
  }
  protoOf(Companion).x14 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion).hu = function (typeParamsSerializers) {
    return this.x14();
  };
  var Companion_instance;
  function Companion_getInstance() {
    WoodSpeciesState_initEntries();
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function values() {
    return [WoodSpeciesState_Exists_getInstance(), WoodSpeciesState_Deleted_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'Exists':
        return WoodSpeciesState_Exists_getInstance();
      case 'Deleted':
        return WoodSpeciesState_Deleted_getInstance();
      default:
        WoodSpeciesState_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var WoodSpeciesState_entriesInitialized;
  function WoodSpeciesState_initEntries() {
    if (WoodSpeciesState_entriesInitialized)
      return Unit_instance;
    WoodSpeciesState_entriesInitialized = true;
    WoodSpeciesState_Exists_instance = new WoodSpeciesState('Exists', 0, 0);
    WoodSpeciesState_Deleted_instance = new WoodSpeciesState('Deleted', 1, 1);
    Companion_getInstance();
  }
  function WoodSpeciesState(name, ordinal, position) {
    Enum.call(this, name, ordinal);
    this.a2l_1 = position;
  }
  protoOf(WoodSpeciesState).y2c = function (_set____db54di) {
    this.a2l_1 = _set____db54di;
  };
  protoOf(WoodSpeciesState).jr = function () {
    return this.a2l_1;
  };
  function S2$woodSpeciesAutomate$lambda($this$s2Sourcing) {
    $this$s2Sourcing.j27_1 = 'WoodSpecies-V2';
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.woodSpecies.domain.automate.S2.woodSpeciesAutomate.<anonymous>.<anonymous>' call
    builder.o27_1 = WoodSpeciesState_Exists_getInstance();
    builder.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver = builder.m27_1;
    var tmp = tmp0_safe_receiver == null ? null : toValue(tmp0_safe_receiver);
    var tmp_0 = toValue(builder.c24());
    var tmp_1 = toValue_0(builder.d24());
    var tmp_2 = toValue_1(getKClass(WoodSpeciesImportCommand));
    var tmp1_elvis_lhs = builder.q27_1;
    var this_0 = new S2Transition(tmp, tmp_0, tmp_1, tmp_2, toValue_1(tmp1_elvis_lhs == null ? getKClass(WoodSpeciesImportedEvent) : tmp1_elvis_lhs));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_0);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_0 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.woodSpecies.domain.automate.S2.woodSpeciesAutomate.<anonymous>.<anonymous>' call
    builder_0.o27_1 = WoodSpeciesState_Deleted_getInstance();
    builder_0.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = builder_0.m27_1;
    var tmp_3 = tmp0_safe_receiver_0 == null ? null : toValue(tmp0_safe_receiver_0);
    var tmp_4 = toValue(builder_0.c24());
    var tmp_5 = toValue_0(builder_0.d24());
    var tmp_6 = toValue_1(getKClass(WoodSpeciesImportCommand));
    var tmp1_elvis_lhs_0 = builder_0.q27_1;
    var this_1 = new S2Transition(tmp_3, tmp_4, tmp_5, tmp_6, toValue_1(tmp1_elvis_lhs_0 == null ? getKClass(WoodSpeciesImportedEvent) : tmp1_elvis_lhs_0));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_1);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_1 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.woodSpecies.domain.automate.S2.woodSpeciesAutomate.<anonymous>.<anonymous>' call
    builder_1.o27_1 = WoodSpeciesState_Exists_getInstance();
    builder_1.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_1 = builder_1.m27_1;
    var tmp_7 = tmp0_safe_receiver_1 == null ? null : toValue(tmp0_safe_receiver_1);
    var tmp_8 = toValue(builder_1.c24());
    var tmp_9 = toValue_0(builder_1.d24());
    var tmp_10 = toValue_1(getKClass(WoodSpeciesCreateCommand));
    var tmp1_elvis_lhs_1 = builder_1.q27_1;
    var this_2 = new S2Transition(tmp_7, tmp_8, tmp_9, tmp_10, toValue_1(tmp1_elvis_lhs_1 == null ? getKClass(WoodSpeciesCreatedEvent) : tmp1_elvis_lhs_1));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_2);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_2 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.woodSpecies.domain.automate.S2.woodSpeciesAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_3 = builder_2.r27_1;
    var element = WoodSpeciesState_Exists_getInstance();
    this_3.r(element);
    builder_2.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_4 = builder_2.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
    var tmp0_iterator = this_4.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_11 = toValue(item);
      var tmp_12 = toValue(item);
      var tmp_13 = toValue_0(builder_2.d24());
      var tmp_14 = toValue_1(getKClass(WoodSpeciesUpdateCommand));
      var tmp0_elvis_lhs = builder_2.t27_1;
      var tmp$ret$6 = new S2Transition(tmp_11, tmp_12, tmp_13, tmp_14, toValue_1(tmp0_elvis_lhs == null ? getKClass(WoodSpeciesUpdatedEvent) : tmp0_elvis_lhs));
      destination.r(tmp$ret$6);
    }
    var tmp3_forEach_receiver = $this$s2Sourcing.l27_1;
    var tmp0_iterator_0 = destination.u();
    while (tmp0_iterator_0.v()) {
      var element_0 = tmp0_iterator_0.w();
      invoke$add(tmp3_forEach_receiver, element_0);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_3 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.woodSpecies.domain.automate.S2.woodSpeciesAutomate.<anonymous>.<anonymous>' call
    builder_3.m27_1 = WoodSpeciesState_Exists_getInstance();
    builder_3.o27_1 = WoodSpeciesState_Deleted_getInstance();
    builder_3.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_2 = builder_3.m27_1;
    var tmp_15 = tmp0_safe_receiver_2 == null ? null : toValue(tmp0_safe_receiver_2);
    var tmp_16 = toValue(builder_3.c24());
    var tmp_17 = toValue_0(builder_3.d24());
    var tmp_18 = toValue_1(getKClass(WoodSpeciesDeleteCommand));
    var tmp1_elvis_lhs_2 = builder_3.q27_1;
    var this_5 = new S2Transition(tmp_15, tmp_16, tmp_17, tmp_18, toValue_1(tmp1_elvis_lhs_2 == null ? getKClass(WoodSpeciesDeletedEvent) : tmp1_elvis_lhs_2));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_5);
    return Unit_instance;
  }
  function invoke$add(receiver, p0) {
    receiver.r(p0);
  }
  function S2() {
    S2_instance = this;
    var tmp = this;
    tmp.b2l_1 = s2Sourcing(S2$woodSpeciesAutomate$lambda);
  }
  var S2_instance;
  function S2_getInstance() {
    if (S2_instance == null)
      new S2();
    return S2_instance;
  }
  function User() {
    User_instance = this;
    UserRole.call(this, 'User');
  }
  var User_instance;
  function User_getInstance() {
    if (User_instance == null)
      new User();
    return User_instance;
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.woodSpecies.domain.automate.UserRole', this, 1);
    tmp0_serialDesc.ht('name', false);
    this.d2l_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.d2l_1;
  };
  protoOf($serializer).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.d2l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return UserRole_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer).e2l = function (encoder, value) {
    var tmp0_desc = this.d2l_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.h9());
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.e2l(encoder, value instanceof UserRole ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance_0() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function UserRole_init_$Init$(seen1, name, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_0().d2l_1);
    }
    $this.c2l_1 = name;
    return $this;
  }
  function UserRole_init_$Create$(seen1, name, serializationConstructorMarker) {
    return UserRole_init_$Init$(seen1, name, serializationConstructorMarker, objectCreate(protoOf(UserRole)));
  }
  function UserRole(name) {
    this.c2l_1 = name;
  }
  protoOf(UserRole).h9 = function () {
    return this.c2l_1;
  };
  protoOf(UserRole).toString = function () {
    return this.h9();
  };
  function WoodSpeciesState_Exists_getInstance() {
    WoodSpeciesState_initEntries();
    return WoodSpeciesState_Exists_instance;
  }
  function WoodSpeciesState_Deleted_getInstance() {
    WoodSpeciesState_initEntries();
    return WoodSpeciesState_Deleted_instance;
  }
  function WoodSpeciesCreateCommandDTO() {
  }
  function WoodSpeciesCreatedEventDTO() {
  }
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.woodSpecies.domain.command.WoodSpeciesCreateCommand', this, 2);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    this.f2l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ii = function () {
    return this.f2l_1;
  };
  protoOf($serializer_0).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_0).ki = function (decoder) {
    var tmp0_desc = this.f2l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return WoodSpeciesCreateCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_0).g2l = function (encoder, value) {
    var tmp0_desc = this.f2l_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.h2l_1);
    tmp1_output.nn(tmp0_desc, 1, StringSerializer_getInstance(), value.i2l_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_0).ji = function (encoder, value) {
    return this.g2l(encoder, value instanceof WoodSpeciesCreateCommand ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_1() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function WoodSpeciesCreateCommand_init_$Init$(seen1, name, img, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_1().f2l_1);
    }
    $this.h2l_1 = name;
    $this.i2l_1 = img;
    return $this;
  }
  function WoodSpeciesCreateCommand_init_$Create$(seen1, name, img, serializationConstructorMarker) {
    return WoodSpeciesCreateCommand_init_$Init$(seen1, name, img, serializationConstructorMarker, objectCreate(protoOf(WoodSpeciesCreateCommand)));
  }
  function WoodSpeciesCreateCommand(name, img) {
    this.h2l_1 = name;
    this.i2l_1 = img;
  }
  protoOf(WoodSpeciesCreateCommand).h9 = function () {
    return this.h2l_1;
  };
  protoOf(WoodSpeciesCreateCommand).d2d = function () {
    return this.i2l_1;
  };
  protoOf(WoodSpeciesCreateCommand).toString = function () {
    return 'WoodSpeciesCreateCommand(name=' + this.h2l_1 + ', img=' + this.i2l_1 + ')';
  };
  protoOf(WoodSpeciesCreateCommand).hashCode = function () {
    var result = getStringHashCode(this.h2l_1);
    result = imul(result, 31) + (this.i2l_1 == null ? 0 : getStringHashCode(this.i2l_1)) | 0;
    return result;
  };
  protoOf(WoodSpeciesCreateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WoodSpeciesCreateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof WoodSpeciesCreateCommand ? other : THROW_CCE();
    if (!(this.h2l_1 === tmp0_other_with_cast.h2l_1))
      return false;
    if (!(this.i2l_1 == tmp0_other_with_cast.i2l_1))
      return false;
    return true;
  };
  function Companion_2() {
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('WoodSpeciesCreatedEvent', this, 4);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('time', false);
    this.j2l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ii = function () {
    return this.j2l_1;
  };
  protoOf($serializer_1).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_1).ki = function (decoder) {
    var tmp0_desc = this.j2l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.ul(tmp0_desc);
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.im(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.im(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return WoodSpeciesCreatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_1).k2l = function (encoder, value) {
    var tmp0_desc = this.j2l_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.l2l_1);
    tmp1_output.jn(tmp0_desc, 1, value.m2l_1);
    tmp1_output.nn(tmp0_desc, 2, $serializer_getInstance(), value.n2l_1);
    tmp1_output.nn(tmp0_desc, 3, LongSerializer_getInstance(), value.o2l_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_1).ji = function (encoder, value) {
    return this.k2l(encoder, value instanceof WoodSpeciesCreatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_2() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function WoodSpeciesCreatedEvent_init_$Init$(seen1, id, name, img, time, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_2().j2l_1);
    }
    $this.l2l_1 = id;
    $this.m2l_1 = name;
    $this.n2l_1 = img;
    $this.o2l_1 = time;
    return $this;
  }
  function WoodSpeciesCreatedEvent_init_$Create$(seen1, id, name, img, time, serializationConstructorMarker) {
    return WoodSpeciesCreatedEvent_init_$Init$(seen1, id, name, img, time, serializationConstructorMarker, objectCreate(protoOf(WoodSpeciesCreatedEvent)));
  }
  function WoodSpeciesCreatedEvent(id, name, img, time) {
    this.l2l_1 = id;
    this.m2l_1 = name;
    this.n2l_1 = img;
    this.o2l_1 = time;
  }
  protoOf(WoodSpeciesCreatedEvent).k1y = function () {
    return this.l2l_1;
  };
  protoOf(WoodSpeciesCreatedEvent).h9 = function () {
    return this.m2l_1;
  };
  protoOf(WoodSpeciesCreatedEvent).d2d = function () {
    return this.n2l_1;
  };
  protoOf(WoodSpeciesCreatedEvent).g2c = function () {
    return this.o2l_1;
  };
  protoOf(WoodSpeciesCreatedEvent).s2Id = function () {
    return this.l2l_1;
  };
  protoOf(WoodSpeciesCreatedEvent).toString = function () {
    return 'WoodSpeciesCreatedEvent(id=' + this.l2l_1 + ', name=' + this.m2l_1 + ', img=' + this.n2l_1 + ', time=' + toString(this.o2l_1) + ')';
  };
  protoOf(WoodSpeciesCreatedEvent).hashCode = function () {
    var result = getStringHashCode(this.l2l_1);
    result = imul(result, 31) + getStringHashCode(this.m2l_1) | 0;
    result = imul(result, 31) + (this.n2l_1 == null ? 0 : this.n2l_1.hashCode()) | 0;
    result = imul(result, 31) + (this.o2l_1 == null ? 0 : this.o2l_1.hashCode()) | 0;
    return result;
  };
  protoOf(WoodSpeciesCreatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WoodSpeciesCreatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof WoodSpeciesCreatedEvent ? other : THROW_CCE();
    if (!(this.l2l_1 === tmp0_other_with_cast.l2l_1))
      return false;
    if (!(this.m2l_1 === tmp0_other_with_cast.m2l_1))
      return false;
    if (!equals(this.n2l_1, tmp0_other_with_cast.n2l_1))
      return false;
    if (!equals(this.o2l_1, tmp0_other_with_cast.o2l_1))
      return false;
    return true;
  };
  function WoodSpeciesDeleteCommandDTO() {
  }
  function WoodSpeciesDeletedEventDTO() {
  }
  function Companion_3() {
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    return Companion_instance_3;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.woodSpecies.domain.command.WoodSpeciesDeleteCommand', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.p2l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ii = function () {
    return this.p2l_1;
  };
  protoOf($serializer_2).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_2).ki = function (decoder) {
    var tmp0_desc = this.p2l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return WoodSpeciesDeleteCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_2).q2l = function (encoder, value) {
    var tmp0_desc = this.p2l_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.r2l_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_2).ji = function (encoder, value) {
    return this.q2l(encoder, value instanceof WoodSpeciesDeleteCommand ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_3() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function WoodSpeciesDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_3().p2l_1);
    }
    $this.r2l_1 = id;
    return $this;
  }
  function WoodSpeciesDeleteCommand_init_$Create$(seen1, id, serializationConstructorMarker) {
    return WoodSpeciesDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(WoodSpeciesDeleteCommand)));
  }
  function WoodSpeciesDeleteCommand(id) {
    this.r2l_1 = id;
  }
  protoOf(WoodSpeciesDeleteCommand).k1y = function () {
    return this.r2l_1;
  };
  protoOf(WoodSpeciesDeleteCommand).toString = function () {
    return 'WoodSpeciesDeleteCommand(id=' + this.r2l_1 + ')';
  };
  protoOf(WoodSpeciesDeleteCommand).hashCode = function () {
    return getStringHashCode(this.r2l_1);
  };
  protoOf(WoodSpeciesDeleteCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WoodSpeciesDeleteCommand))
      return false;
    var tmp0_other_with_cast = other instanceof WoodSpeciesDeleteCommand ? other : THROW_CCE();
    if (!(this.r2l_1 === tmp0_other_with_cast.r2l_1))
      return false;
    return true;
  };
  function Companion_4() {
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('WoodSpeciesDeletedEvent', this, 2);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('time', false);
    this.s2l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ii = function () {
    return this.s2l_1;
  };
  protoOf($serializer_3).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_3).ki = function (decoder) {
    var tmp0_desc = this.s2l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.im(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.im(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return WoodSpeciesDeletedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_3).t2l = function (encoder, value) {
    var tmp0_desc = this.s2l_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.u2l_1);
    tmp1_output.nn(tmp0_desc, 1, LongSerializer_getInstance(), value.v2l_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_3).ji = function (encoder, value) {
    return this.t2l(encoder, value instanceof WoodSpeciesDeletedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_4() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function WoodSpeciesDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_4().s2l_1);
    }
    $this.u2l_1 = id;
    $this.v2l_1 = time;
    return $this;
  }
  function WoodSpeciesDeletedEvent_init_$Create$(seen1, id, time, serializationConstructorMarker) {
    return WoodSpeciesDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, objectCreate(protoOf(WoodSpeciesDeletedEvent)));
  }
  function WoodSpeciesDeletedEvent(id, time) {
    this.u2l_1 = id;
    this.v2l_1 = time;
  }
  protoOf(WoodSpeciesDeletedEvent).k1y = function () {
    return this.u2l_1;
  };
  protoOf(WoodSpeciesDeletedEvent).g2c = function () {
    return this.v2l_1;
  };
  protoOf(WoodSpeciesDeletedEvent).s2Id = function () {
    return this.u2l_1;
  };
  protoOf(WoodSpeciesDeletedEvent).toString = function () {
    return 'WoodSpeciesDeletedEvent(id=' + this.u2l_1 + ', time=' + toString(this.v2l_1) + ')';
  };
  protoOf(WoodSpeciesDeletedEvent).hashCode = function () {
    var result = getStringHashCode(this.u2l_1);
    result = imul(result, 31) + (this.v2l_1 == null ? 0 : this.v2l_1.hashCode()) | 0;
    return result;
  };
  protoOf(WoodSpeciesDeletedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WoodSpeciesDeletedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof WoodSpeciesDeletedEvent ? other : THROW_CCE();
    if (!(this.u2l_1 === tmp0_other_with_cast.u2l_1))
      return false;
    if (!equals(this.v2l_1, tmp0_other_with_cast.v2l_1))
      return false;
    return true;
  };
  function WoodSpeciesImportCommandDTO() {
  }
  function WoodSpeciesImportedEventDTO() {
  }
  function Companion_5() {
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.woodSpecies.domain.command.WoodSpeciesImportCommand', this, 1);
    tmp0_serialDesc.ht('item', false);
    this.w2l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ii = function () {
    return this.w2l_1;
  };
  protoOf($serializer_4).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_9()];
  };
  protoOf($serializer_4).ki = function (decoder) {
    var tmp0_desc = this.w2l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return WoodSpeciesImportCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_4).x2l = function (encoder, value) {
    var tmp0_desc = this.w2l_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_9(), value.y2l_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_4).ji = function (encoder, value) {
    return this.x2l(encoder, value instanceof WoodSpeciesImportCommand ? value : THROW_CCE());
  };
  var $serializer_instance_4;
  function $serializer_getInstance_5() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function WoodSpeciesImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_5().w2l_1);
    }
    $this.y2l_1 = item;
    return $this;
  }
  function WoodSpeciesImportCommand_init_$Create$(seen1, item, serializationConstructorMarker) {
    return WoodSpeciesImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, objectCreate(protoOf(WoodSpeciesImportCommand)));
  }
  function WoodSpeciesImportCommand(item) {
    this.y2l_1 = item;
  }
  protoOf(WoodSpeciesImportCommand).q20 = function () {
    return this.y2l_1;
  };
  protoOf(WoodSpeciesImportCommand).toString = function () {
    return 'WoodSpeciesImportCommand(item=' + this.y2l_1 + ')';
  };
  protoOf(WoodSpeciesImportCommand).hashCode = function () {
    return this.y2l_1.hashCode();
  };
  protoOf(WoodSpeciesImportCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WoodSpeciesImportCommand))
      return false;
    var tmp0_other_with_cast = other instanceof WoodSpeciesImportCommand ? other : THROW_CCE();
    if (!this.y2l_1.equals(tmp0_other_with_cast.y2l_1))
      return false;
    return true;
  };
  function Companion_6() {
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('WoodSpeciesImportedEvent', this, 2);
    tmp0_serialDesc.ht('item', false);
    tmp0_serialDesc.ht('time', false);
    this.z2l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).ii = function () {
    return this.z2l_1;
  };
  protoOf($serializer_5).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_9(), LongSerializer_getInstance()];
  };
  protoOf($serializer_5).ki = function (decoder) {
    var tmp0_desc = this.z2l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return WoodSpeciesImportedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_5).a2m = function (encoder, value) {
    var tmp0_desc = this.z2l_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_9(), value.b2m_1);
    tmp1_output.fn(tmp0_desc, 1, value.c2m_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_5).ji = function (encoder, value) {
    return this.a2m(encoder, value instanceof WoodSpeciesImportedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_5;
  function $serializer_getInstance_6() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function WoodSpeciesImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_6().z2l_1);
    }
    $this.b2m_1 = item;
    $this.c2m_1 = time;
    return $this;
  }
  function WoodSpeciesImportedEvent_init_$Create$(seen1, item, time, serializationConstructorMarker) {
    return WoodSpeciesImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, objectCreate(protoOf(WoodSpeciesImportedEvent)));
  }
  function WoodSpeciesImportedEvent(item, time) {
    this.b2m_1 = item;
    this.c2m_1 = time;
  }
  protoOf(WoodSpeciesImportedEvent).q20 = function () {
    return this.b2m_1;
  };
  protoOf(WoodSpeciesImportedEvent).g2c = function () {
    return this.c2m_1;
  };
  protoOf(WoodSpeciesImportedEvent).s2Id = function () {
    return this.b2m_1.d2m_1;
  };
  protoOf(WoodSpeciesImportedEvent).toString = function () {
    return 'WoodSpeciesImportedEvent(item=' + this.b2m_1 + ', time=' + this.c2m_1.toString() + ')';
  };
  protoOf(WoodSpeciesImportedEvent).hashCode = function () {
    var result = this.b2m_1.hashCode();
    result = imul(result, 31) + this.c2m_1.hashCode() | 0;
    return result;
  };
  protoOf(WoodSpeciesImportedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WoodSpeciesImportedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof WoodSpeciesImportedEvent ? other : THROW_CCE();
    if (!this.b2m_1.equals(tmp0_other_with_cast.b2m_1))
      return false;
    if (!this.c2m_1.equals(tmp0_other_with_cast.c2m_1))
      return false;
    return true;
  };
  function WoodSpeciesUpdateCommandDTO() {
  }
  function WoodSpeciesUpdatedEventDTO() {
  }
  function Companion_7() {
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    return Companion_instance_7;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.woodSpecies.domain.command.WoodSpeciesUpdateCommand', this, 3);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    this.j2m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).ii = function () {
    return this.j2m_1;
  };
  protoOf($serializer_6).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_6).ki = function (decoder) {
    var tmp0_desc = this.j2m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.ul(tmp0_desc);
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return WoodSpeciesUpdateCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_6).k2m = function (encoder, value) {
    var tmp0_desc = this.j2m_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.l2m_1);
    tmp1_output.jn(tmp0_desc, 1, value.m2m_1);
    tmp1_output.nn(tmp0_desc, 2, StringSerializer_getInstance(), value.n2m_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_6).ji = function (encoder, value) {
    return this.k2m(encoder, value instanceof WoodSpeciesUpdateCommand ? value : THROW_CCE());
  };
  var $serializer_instance_6;
  function $serializer_getInstance_7() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function WoodSpeciesUpdateCommand_init_$Init$(seen1, id, name, img, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_7().j2m_1);
    }
    $this.l2m_1 = id;
    $this.m2m_1 = name;
    $this.n2m_1 = img;
    return $this;
  }
  function WoodSpeciesUpdateCommand_init_$Create$(seen1, id, name, img, serializationConstructorMarker) {
    return WoodSpeciesUpdateCommand_init_$Init$(seen1, id, name, img, serializationConstructorMarker, objectCreate(protoOf(WoodSpeciesUpdateCommand)));
  }
  function WoodSpeciesUpdateCommand(id, name, img) {
    this.l2m_1 = id;
    this.m2m_1 = name;
    this.n2m_1 = img;
  }
  protoOf(WoodSpeciesUpdateCommand).k1y = function () {
    return this.l2m_1;
  };
  protoOf(WoodSpeciesUpdateCommand).h9 = function () {
    return this.m2m_1;
  };
  protoOf(WoodSpeciesUpdateCommand).d2d = function () {
    return this.n2m_1;
  };
  protoOf(WoodSpeciesUpdateCommand).toString = function () {
    return 'WoodSpeciesUpdateCommand(id=' + this.l2m_1 + ', name=' + this.m2m_1 + ', img=' + this.n2m_1 + ')';
  };
  protoOf(WoodSpeciesUpdateCommand).hashCode = function () {
    var result = getStringHashCode(this.l2m_1);
    result = imul(result, 31) + getStringHashCode(this.m2m_1) | 0;
    result = imul(result, 31) + (this.n2m_1 == null ? 0 : getStringHashCode(this.n2m_1)) | 0;
    return result;
  };
  protoOf(WoodSpeciesUpdateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WoodSpeciesUpdateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof WoodSpeciesUpdateCommand ? other : THROW_CCE();
    if (!(this.l2m_1 === tmp0_other_with_cast.l2m_1))
      return false;
    if (!(this.m2m_1 === tmp0_other_with_cast.m2m_1))
      return false;
    if (!(this.n2m_1 == tmp0_other_with_cast.n2m_1))
      return false;
    return true;
  };
  function Companion_8() {
  }
  var Companion_instance_8;
  function Companion_getInstance_8() {
    return Companion_instance_8;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('WoodSpeciesUpdatedEvent', this, 4);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('time', false);
    this.o2m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).ii = function () {
    return this.o2m_1;
  };
  protoOf($serializer_7).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_7).ki = function (decoder) {
    var tmp0_desc = this.o2m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.ul(tmp0_desc);
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.im(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.im(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return WoodSpeciesUpdatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_7).p2m = function (encoder, value) {
    var tmp0_desc = this.o2m_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.q2m_1);
    tmp1_output.jn(tmp0_desc, 1, value.r2m_1);
    tmp1_output.nn(tmp0_desc, 2, $serializer_getInstance(), value.s2m_1);
    tmp1_output.nn(tmp0_desc, 3, LongSerializer_getInstance(), value.t2m_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_7).ji = function (encoder, value) {
    return this.p2m(encoder, value instanceof WoodSpeciesUpdatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_7;
  function $serializer_getInstance_8() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function WoodSpeciesUpdatedEvent_init_$Init$(seen1, id, name, img, time, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_8().o2m_1);
    }
    $this.q2m_1 = id;
    $this.r2m_1 = name;
    $this.s2m_1 = img;
    $this.t2m_1 = time;
    return $this;
  }
  function WoodSpeciesUpdatedEvent_init_$Create$(seen1, id, name, img, time, serializationConstructorMarker) {
    return WoodSpeciesUpdatedEvent_init_$Init$(seen1, id, name, img, time, serializationConstructorMarker, objectCreate(protoOf(WoodSpeciesUpdatedEvent)));
  }
  function WoodSpeciesUpdatedEvent(id, name, img, time) {
    this.q2m_1 = id;
    this.r2m_1 = name;
    this.s2m_1 = img;
    this.t2m_1 = time;
  }
  protoOf(WoodSpeciesUpdatedEvent).k1y = function () {
    return this.q2m_1;
  };
  protoOf(WoodSpeciesUpdatedEvent).h9 = function () {
    return this.r2m_1;
  };
  protoOf(WoodSpeciesUpdatedEvent).d2d = function () {
    return this.s2m_1;
  };
  protoOf(WoodSpeciesUpdatedEvent).g2c = function () {
    return this.t2m_1;
  };
  protoOf(WoodSpeciesUpdatedEvent).s2Id = function () {
    return this.q2m_1;
  };
  protoOf(WoodSpeciesUpdatedEvent).toString = function () {
    return 'WoodSpeciesUpdatedEvent(id=' + this.q2m_1 + ', name=' + this.r2m_1 + ', img=' + this.s2m_1 + ', time=' + toString(this.t2m_1) + ')';
  };
  protoOf(WoodSpeciesUpdatedEvent).hashCode = function () {
    var result = getStringHashCode(this.q2m_1);
    result = imul(result, 31) + getStringHashCode(this.r2m_1) | 0;
    result = imul(result, 31) + (this.s2m_1 == null ? 0 : this.s2m_1.hashCode()) | 0;
    result = imul(result, 31) + (this.t2m_1 == null ? 0 : this.t2m_1.hashCode()) | 0;
    return result;
  };
  protoOf(WoodSpeciesUpdatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WoodSpeciesUpdatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof WoodSpeciesUpdatedEvent ? other : THROW_CCE();
    if (!(this.q2m_1 === tmp0_other_with_cast.q2m_1))
      return false;
    if (!(this.r2m_1 === tmp0_other_with_cast.r2m_1))
      return false;
    if (!equals(this.s2m_1, tmp0_other_with_cast.s2m_1))
      return false;
    if (!equals(this.t2m_1, tmp0_other_with_cast.t2m_1))
      return false;
    return true;
  };
  function WoodSpeciesModelDTO() {
  }
  function Companion_9() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u2m_1 = [null, Companion_getInstance().x14(), null, null, null, null];
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.woodSpecies.domain.model.WoodSpeciesModel', this, 6);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('creationDate', false);
    tmp0_serialDesc.ht('updatedDate', false);
    this.v2m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).ii = function () {
    return this.v2m_1;
  };
  protoOf($serializer_8).wt = function () {
    var tmp0_cached = Companion_getInstance_9().u2m_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], StringSerializer_getInstance(), get_nullable($serializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_8).ki = function (decoder) {
    var tmp0_desc = this.v2m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.ul(tmp0_desc);
    var tmp11_cached = Companion_getInstance_9().u2m_1;
    if (tmp10_input.km()) {
      tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.gm(tmp0_desc, 1, tmp11_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.im(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.im(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.gm(tmp0_desc, 1, tmp11_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.im(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.im(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.vl(tmp0_desc);
    return WoodSpeciesModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_8).w2m = function (encoder, value) {
    var tmp0_desc = this.v2m_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_9().u2m_1;
    tmp1_output.jn(tmp0_desc, 0, value.d2m_1);
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.e2m_1);
    tmp1_output.jn(tmp0_desc, 2, value.f2m_1);
    tmp1_output.nn(tmp0_desc, 3, $serializer_getInstance(), value.g2m_1);
    tmp1_output.nn(tmp0_desc, 4, LongSerializer_getInstance(), value.h2m_1);
    tmp1_output.nn(tmp0_desc, 5, LongSerializer_getInstance(), value.i2m_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_8).ji = function (encoder, value) {
    return this.w2m(encoder, value instanceof WoodSpeciesModel ? value : THROW_CCE());
  };
  var $serializer_instance_8;
  function $serializer_getInstance_9() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function WoodSpeciesModel_init_$Init$(seen1, id, status, name, img, creationDate, updatedDate, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen1))) {
      throwMissingFieldException(seen1, 63, $serializer_getInstance_9().v2m_1);
    }
    $this.d2m_1 = id;
    $this.e2m_1 = status;
    $this.f2m_1 = name;
    $this.g2m_1 = img;
    $this.h2m_1 = creationDate;
    $this.i2m_1 = updatedDate;
    return $this;
  }
  function WoodSpeciesModel_init_$Create$(seen1, id, status, name, img, creationDate, updatedDate, serializationConstructorMarker) {
    return WoodSpeciesModel_init_$Init$(seen1, id, status, name, img, creationDate, updatedDate, serializationConstructorMarker, objectCreate(protoOf(WoodSpeciesModel)));
  }
  function WoodSpeciesModel() {
  }
  protoOf(WoodSpeciesModel).k1y = function () {
    return this.d2m_1;
  };
  protoOf(WoodSpeciesModel).y2f = function () {
    return this.e2m_1;
  };
  protoOf(WoodSpeciesModel).h9 = function () {
    return this.f2m_1;
  };
  protoOf(WoodSpeciesModel).d2d = function () {
    return this.g2m_1;
  };
  protoOf(WoodSpeciesModel).v2h = function () {
    return this.h2m_1;
  };
  protoOf(WoodSpeciesModel).w2h = function () {
    return this.i2m_1;
  };
  protoOf(WoodSpeciesModel).s2State = function () {
    return this.e2m_1;
  };
  protoOf(WoodSpeciesModel).s2Id = function () {
    return this.d2m_1;
  };
  protoOf(WoodSpeciesModel).toString = function () {
    return 'WoodSpeciesModel(id=' + this.d2m_1 + ', status=' + this.e2m_1 + ', name=' + this.f2m_1 + ', img=' + this.g2m_1 + ', creationDate=' + toString(this.h2m_1) + ', updatedDate=' + toString(this.i2m_1) + ')';
  };
  protoOf(WoodSpeciesModel).hashCode = function () {
    var result = getStringHashCode(this.d2m_1);
    result = imul(result, 31) + this.e2m_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.f2m_1) | 0;
    result = imul(result, 31) + (this.g2m_1 == null ? 0 : this.g2m_1.hashCode()) | 0;
    result = imul(result, 31) + (this.h2m_1 == null ? 0 : this.h2m_1.hashCode()) | 0;
    result = imul(result, 31) + (this.i2m_1 == null ? 0 : this.i2m_1.hashCode()) | 0;
    return result;
  };
  protoOf(WoodSpeciesModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WoodSpeciesModel))
      return false;
    var tmp0_other_with_cast = other instanceof WoodSpeciesModel ? other : THROW_CCE();
    if (!(this.d2m_1 === tmp0_other_with_cast.d2m_1))
      return false;
    if (!this.e2m_1.equals(tmp0_other_with_cast.e2m_1))
      return false;
    if (!(this.f2m_1 === tmp0_other_with_cast.f2m_1))
      return false;
    if (!equals(this.g2m_1, tmp0_other_with_cast.g2m_1))
      return false;
    if (!equals(this.h2m_1, tmp0_other_with_cast.h2m_1))
      return false;
    if (!equals(this.i2m_1, tmp0_other_with_cast.i2m_1))
      return false;
    return true;
  };
  function WoodSpeciesPolicies() {
  }
  protoOf(WoodSpeciesPolicies).canPage = function (authedUser) {
    return true;
  };
  protoOf(WoodSpeciesPolicies).canGet = function (authedUser) {
    return true;
  };
  protoOf(WoodSpeciesPolicies).canCreate = function (authedUser) {
    return hasRole(authedUser, 'Marque');
  };
  protoOf(WoodSpeciesPolicies).canUpdate = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().b2l_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(WoodSpeciesUpdateCommand).z5()))) {
      // Inline function 'org.boislocal.platform.s2.woodSpecies.domain.policy.WoodSpeciesPolicies.canUpdate.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(WoodSpeciesPolicies).canDelete = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().b2l_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(WoodSpeciesDeleteCommand).z5()))) {
      // Inline function 'org.boislocal.platform.s2.woodSpecies.domain.policy.WoodSpeciesPolicies.canDelete.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  var WoodSpeciesPolicies_instance;
  function WoodSpeciesPolicies_getInstance() {
    return WoodSpeciesPolicies_instance;
  }
  function WoodSpeciesGetQueryDTO() {
  }
  function WoodSpeciesGetResponseDTO() {
  }
  function WoodSpeciesPageQueryDTO() {
  }
  function WoodSpeciesPageResponseDTO() {
  }
  //region block: post-declaration
  defineProp(protoOf(WoodSpeciesState), 'position', function () {
    return this.jr();
  }, function (value) {
    this.y2c(value);
  });
  defineProp(protoOf(WoodSpeciesState), 'name', protoOf(WoodSpeciesState).h9);
  defineProp(protoOf(WoodSpeciesState), 'ordinal', protoOf(WoodSpeciesState).i9);
  protoOf($serializer).xt = typeParametersSerializers;
  protoOf($serializer_0).xt = typeParametersSerializers;
  defineProp(protoOf(WoodSpeciesCreateCommand), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(WoodSpeciesCreateCommand), 'img', function () {
    return this.d2d();
  });
  protoOf($serializer_1).xt = typeParametersSerializers;
  defineProp(protoOf(WoodSpeciesCreatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(WoodSpeciesCreatedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(WoodSpeciesCreatedEvent), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(WoodSpeciesCreatedEvent), 'time');
  protoOf($serializer_2).xt = typeParametersSerializers;
  defineProp(protoOf(WoodSpeciesDeleteCommand), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_3).xt = typeParametersSerializers;
  defineProp(protoOf(WoodSpeciesDeletedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(WoodSpeciesDeletedEvent), 'time');
  protoOf($serializer_4).xt = typeParametersSerializers;
  defineProp(protoOf(WoodSpeciesImportCommand), 'item', function () {
    return this.q20();
  });
  protoOf($serializer_5).xt = typeParametersSerializers;
  defineProp(protoOf(WoodSpeciesImportedEvent), 'item', function () {
    return this.q20();
  });
  defineProp(protoOf(WoodSpeciesImportedEvent), 'time');
  protoOf($serializer_6).xt = typeParametersSerializers;
  defineProp(protoOf(WoodSpeciesUpdateCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(WoodSpeciesUpdateCommand), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(WoodSpeciesUpdateCommand), 'img', function () {
    return this.d2d();
  });
  protoOf($serializer_7).xt = typeParametersSerializers;
  defineProp(protoOf(WoodSpeciesUpdatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(WoodSpeciesUpdatedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(WoodSpeciesUpdatedEvent), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(WoodSpeciesUpdatedEvent), 'time');
  protoOf($serializer_8).xt = typeParametersSerializers;
  defineProp(protoOf(WoodSpeciesModel), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(WoodSpeciesModel), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(WoodSpeciesModel), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(WoodSpeciesModel), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(WoodSpeciesModel), 'creationDate', function () {
    return this.v2h();
  });
  defineProp(protoOf(WoodSpeciesModel), 'updatedDate', function () {
    return this.w2h();
  });
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  Companion_instance_3 = new Companion_3();
  Companion_instance_4 = new Companion_4();
  Companion_instance_5 = new Companion_5();
  Companion_instance_6 = new Companion_6();
  Companion_instance_7 = new Companion_7();
  Companion_instance_8 = new Companion_8();
  WoodSpeciesPolicies_instance = new WoodSpeciesPolicies();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$woodSpecies = $org$boislocal$platform$s2.woodSpecies || ($org$boislocal$platform$s2.woodSpecies = {});
    var $org$boislocal$platform$s2$woodSpecies$domain = $org$boislocal$platform$s2$woodSpecies.domain || ($org$boislocal$platform$s2$woodSpecies.domain = {});
    var $org$boislocal$platform$s2$woodSpecies$domain$automate = $org$boislocal$platform$s2$woodSpecies$domain.automate || ($org$boislocal$platform$s2$woodSpecies$domain.automate = {});
    $org$boislocal$platform$s2$woodSpecies$domain$automate.WoodSpeciesState = WoodSpeciesState;
    $org$boislocal$platform$s2$woodSpecies$domain$automate.WoodSpeciesState.values = values;
    $org$boislocal$platform$s2$woodSpecies$domain$automate.WoodSpeciesState.valueOf = valueOf;
    defineProp($org$boislocal$platform$s2$woodSpecies$domain$automate.WoodSpeciesState, 'Exists', WoodSpeciesState_Exists_getInstance);
    defineProp($org$boislocal$platform$s2$woodSpecies$domain$automate.WoodSpeciesState, 'Deleted', WoodSpeciesState_Deleted_getInstance);
    defineProp($org$boislocal$platform$s2$woodSpecies$domain$automate.WoodSpeciesState, 'Companion', Companion_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$woodSpecies = $org$boislocal$platform$s2.woodSpecies || ($org$boislocal$platform$s2.woodSpecies = {});
    var $org$boislocal$platform$s2$woodSpecies$domain = $org$boislocal$platform$s2$woodSpecies.domain || ($org$boislocal$platform$s2$woodSpecies.domain = {});
    var $org$boislocal$platform$s2$woodSpecies$domain$command = $org$boislocal$platform$s2$woodSpecies$domain.command || ($org$boislocal$platform$s2$woodSpecies$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$woodSpecies = $org$boislocal$platform$s2.woodSpecies || ($org$boislocal$platform$s2.woodSpecies = {});
    var $org$boislocal$platform$s2$woodSpecies$domain = $org$boislocal$platform$s2$woodSpecies.domain || ($org$boislocal$platform$s2$woodSpecies.domain = {});
    var $org$boislocal$platform$s2$woodSpecies$domain$command = $org$boislocal$platform$s2$woodSpecies$domain.command || ($org$boislocal$platform$s2$woodSpecies$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$woodSpecies = $org$boislocal$platform$s2.woodSpecies || ($org$boislocal$platform$s2.woodSpecies = {});
    var $org$boislocal$platform$s2$woodSpecies$domain = $org$boislocal$platform$s2$woodSpecies.domain || ($org$boislocal$platform$s2$woodSpecies.domain = {});
    var $org$boislocal$platform$s2$woodSpecies$domain$command = $org$boislocal$platform$s2$woodSpecies$domain.command || ($org$boislocal$platform$s2$woodSpecies$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$woodSpecies = $org$boislocal$platform$s2.woodSpecies || ($org$boislocal$platform$s2.woodSpecies = {});
    var $org$boislocal$platform$s2$woodSpecies$domain = $org$boislocal$platform$s2$woodSpecies.domain || ($org$boislocal$platform$s2$woodSpecies.domain = {});
    var $org$boislocal$platform$s2$woodSpecies$domain$command = $org$boislocal$platform$s2$woodSpecies$domain.command || ($org$boislocal$platform$s2$woodSpecies$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$woodSpecies = $org$boislocal$platform$s2.woodSpecies || ($org$boislocal$platform$s2.woodSpecies = {});
    var $org$boislocal$platform$s2$woodSpecies$domain = $org$boislocal$platform$s2$woodSpecies.domain || ($org$boislocal$platform$s2$woodSpecies.domain = {});
    var $org$boislocal$platform$s2$woodSpecies$domain$model = $org$boislocal$platform$s2$woodSpecies$domain.model || ($org$boislocal$platform$s2$woodSpecies$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$woodSpecies = $org$boislocal$platform$s2.woodSpecies || ($org$boislocal$platform$s2.woodSpecies = {});
    var $org$boislocal$platform$s2$woodSpecies$domain = $org$boislocal$platform$s2$woodSpecies.domain || ($org$boislocal$platform$s2$woodSpecies.domain = {});
    var $org$boislocal$platform$s2$woodSpecies$domain$policy = $org$boislocal$platform$s2$woodSpecies$domain.policy || ($org$boislocal$platform$s2$woodSpecies$domain.policy = {});
    defineProp($org$boislocal$platform$s2$woodSpecies$domain$policy, 'WoodSpeciesPolicies', WoodSpeciesPolicies_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$woodSpecies = $org$boislocal$platform$s2.woodSpecies || ($org$boislocal$platform$s2.woodSpecies = {});
    var $org$boislocal$platform$s2$woodSpecies$domain = $org$boislocal$platform$s2$woodSpecies.domain || ($org$boislocal$platform$s2$woodSpecies.domain = {});
    var $org$boislocal$platform$s2$woodSpecies$domain$query = $org$boislocal$platform$s2$woodSpecies$domain.query || ($org$boislocal$platform$s2$woodSpecies$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$woodSpecies = $org$boislocal$platform$s2.woodSpecies || ($org$boislocal$platform$s2.woodSpecies = {});
    var $org$boislocal$platform$s2$woodSpecies$domain = $org$boislocal$platform$s2$woodSpecies.domain || ($org$boislocal$platform$s2$woodSpecies.domain = {});
    var $org$boislocal$platform$s2$woodSpecies$domain$query = $org$boislocal$platform$s2$woodSpecies$domain.query || ($org$boislocal$platform$s2$woodSpecies$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = $serializer_getInstance_9;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain.js.map
